import type { LucideProps } from 'lucide-react'
import { Link, useLocation, useNavigate } from 'react-router-dom'

import { paths } from 'src/config/paths'
import TabIconButton from 'src/features/navigation/components/pro-app-frame-tab-icon-button'
import { HelpCenterIcon } from 'src/features/navigation/icons/help-center-icon'
import { Iconmark } from 'src/shared/components/icons/logos/iconmark'

import BCProgressBar from './bc-progressbar'

const BusinessCreateNavbar = () => {
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <div className="flex size-full flex-col items-center justify-between bg-primary px-4 py-5 text-white">
      <Link to={paths.home.getHref()}>
        <Iconmark size={36} />
      </Link>
      <BCProgressBar />
      <TabIconButton
        key="help-center"
        icon={(props: LucideProps) => <HelpCenterIcon size={22} {...props} />}
        onClick={() => navigate(paths.support.path)}
        isActive={location.pathname.startsWith(paths.support.path)}
      />
    </div>
  )
}

export default BusinessCreateNavbar
